import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import localePt from '@angular/common/locales/pt';

import { FeatureImgCloudModule } from '@unico-people/feature-img-cloud';
import { EnvelopeStatusBadgeModule } from '../envelope-status-badge/envelope-status-badge.module';

import { ItemEnvelopeDocumentComponent } from './item-envelope-document.component';

registerLocaleData(localePt, 'pt-BR');

@NgModule({
  imports: [CommonModule, FormsModule, RouterModule, FeatureImgCloudModule, EnvelopeStatusBadgeModule],
  declarations: [ItemEnvelopeDocumentComponent],
  exports: [ItemEnvelopeDocumentComponent],
  providers: [{ provide: LOCALE_ID, useValue: 'pt-BR' }]
})
export class  ItemEnvelopeDocumentModule {}
